import React, { useState } from 'react';
import './ProductCardY.scss';
import TextInput from '../TextInput';
import { Product } from '../../types/Product';
import ProductImage from '../ProductImage';
import { Price } from '../../types/Price';
import { Stock } from '../../types/Stock';
import { ProductType } from '../../types/ProductType';
import _ from 'lodash';
import Button from '../Button';

import { OrderLine } from '../../types/Order';
import { lwRoundNumber, roundNumber } from '../../helpers/functions';
import { useDispatch, useSelector } from 'react-redux';
import { addToBasket } from '../../actions/Order';
import { useHistory } from 'react-router-dom';
import CONSTANTS  from '../../helpers/constants';
import TrashSvg from '../../assets/svgs/trash.svg';
import { emailNotifyStock } from '../../actions/Email';
import { getCustomer } from '../../selectors/Customer';

type Props = {
  product?: Product | null;
  price?: Price | null;
  stock?: Stock | null;
  productType?: ProductType | null
};

const ProductCardY = (props: Props) => {
  const { product, price, productType, stock } = props;
  const dispatch = useDispatch();
  const customer = useSelector(getCustomer);
  const history = useHistory();
  const [currentSQMPacks, setCurrentPacks] = useState(null);
  const [reference, setReference] = useState('');
  const [orderLines, setOrderLines] = useState<OrderLine[]>([]);


  const totalQty = stock?.pallet?.find(p => p.pallet_batchno === 'TOTAL')?.pallet_qty || 0;

  const onNotify = () => {
    dispatch(emailNotifyStock({
      customerName: customer?.NAME || 'N/A',
      productQuality: product?.quality_full_name || 'N/A',
      productColor: product?.colour_full_name || 'N/A',
      productSKU: product?.product_sku || 'N/A',
      rep_email: customer?.rep_email || 'N/A',
      rep_name: customer?.rep_name || 'N/A',
    }));
  };

  const setCurrentSQMPacks = (val: string) => {
    // @ts-ignore
    setCurrentPacks(Math.ceil(lwRoundNumber(val)));
  };

  const onAddPackToOrderSummary = () => {
    const localOrderLines = [...orderLines];
    if (product && price && productType && currentSQMPacks) {
      localOrderLines.push({
        product_sku: product.product_sku,
        product_quality: product.quality_full_name,
        product_type_code: product.product_type_code,
        product_type_code_name: productType.product_type_desc,
        quantity: currentSQMPacks,
        pallet_id: '',
        half_roll: '',
        roll_id: '',
        length: 0,
        width: 0,
        item_price: price.unit_price,
        line_reference: reference,
        line_price: price.unit_price * currentSQMPacks,
        line_discount: price.cut_price_discount,
        colour_full_name: product.colour_full_name,
      });
      setReference('');
      setCurrentSQMPacks('');
      setOrderLines(localOrderLines);
    }
  };

  const onAddOrderSummaryToBasket = () => {
    dispatch(addToBasket(orderLines));
    history.push(CONSTANTS.APP_ROUTES.CART);
  };

  const onAddOrderSummaryToBasketAndContinue = () => {
    dispatch(addToBasket(orderLines));
    history.push(CONSTANTS.APP_ROUTES.DASHBOARD);
  };

  const onMinus = (index: number) => {
    let localOrderLines = [...orderLines];
    localOrderLines = localOrderLines.filter((or, i) => i !== index);
    setOrderLines(localOrderLines);
  };


  const getOrderTotal = () => {
    let total = 0;
    orderLines.forEach(o => total += o?.line_price || 0);
    return total;
  };

  return (
        <div className="product-card-ex">
            <div className="product-card-ex__header">
                <div className="product-card-ex__header__img">
                    <ProductImage imageCode={product?.product_sku} imageAlt={product?.quality_full_name}/>
                    <div className="product-card-ex__header__img__name">
                        <p className="product-card-ex__header__img__name__top">
                            Product Name: {product?.quality_full_name} {product?.colour_full_name}
                        </p>
                        <p className="product-card-ex__header__img__name__bottom">
                            {_.startCase(_.toLower(productType?.product_type_desc))}
                        </p>
                    </div>
                </div>
            </div>

            {/*<!-- PACKS -->*/}
            <div className="product-card-ex__accordion mt-3">
                <div className="product-card-ex__accordion__header">
                    <div className="product-card-ex__accordion__header__title">
                        {product?.quality_full_name} {product?.colour_full_name}
                    </div>
                </div>
                <div className="product-card-ex__accordion__body">
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="product-card-ex__price__right">
                                {stock?.stock_availablity === 'yes' && <div className="green-circle"/>}
                                {stock?.stock_availablity === 'no' && <div className="red-circle"/>}
                                <div className="product-card-ex__price__right__details">
                                    <p className="text-start">
                                        {stock?.stock_availablity === 'yes' ? 'In Stock' : 'Out Of Stock'}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {stock?.stock_availablity === 'no' && <div className="row mb-4">
                        <Button type="link" text="Notify When Back In Stock" onClick={onNotify} />
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row">
                        <div className="col-md-6 justify-content-center d-flex flex-column">
                            <div className="font-bold">QTY</div>
                            <div className="font-small">Enter Quantity Required</div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-8">
                                    <TextInput type="number" bgColor="white" onChange={setCurrentSQMPacks} value={currentSQMPacks}/>
                                </div>
                            </div>
                        </div>
                    </div>}
                    <div>
                        {/* @ts-ignore */}
                        {currentSQMPacks > totalQty && <div className="mb-3 mt-3 alert alert-danger" role="alert">Max available units: {totalQty}</div>}
                    </div>
                    {stock?.stock_availablity === 'yes' &&  <div className="row mt-5">
                        <TextInput bgColor="white" required label="Reference" value={reference} onChange={setReference} />
                    </div>}
                    {stock?.stock_availablity === 'yes' && <div className="row mt-5">
                        <div className="col-3">
                            <span className="font-bold font-size-title">Total</span>
                        </div>
                        <div className="col-5">
                            <span className="font-bold text-orange font-size-title">
                            £{roundNumber((currentSQMPacks || 0) * (price?.unit_price || 0))}
                            </span>
                            <span className="text-small">&nbsp;&nbsp;Excl. VAT</span>
                        </div>
                        <div className="col-4 text-end">
                            <span className="font-bold text-orange font-size-title">
                                £{roundNumber((price?.unit_price || 0))}
                            </span>
                            <span className="text-small">&nbsp;&nbsp;per item</span>
                        </div>
                    </div>
                    }
                    <div className="row mt-5">
                        {stock?.stock_availablity === 'yes' &&
                        <Button text="Add To Order Summary" disabled={!currentSQMPacks || reference.length <= 0 || currentSQMPacks > totalQty}
                                onClick={onAddPackToOrderSummary}/>
                        }
                    </div>
                </div>
            </div>


            {/*<!-- ORDER SUMMARY -->*/}
            <div className="product-card-ex__accordion mt-3">
                <div className="product-card-ex__accordion__header">
                    <div className="product-card-ex__accordion__header__title">
                        Order Summary
                    </div>
                </div>
                <div className="product-card-ex__accordion__body">
                    <div className="row">
                        <div className="col-12"><hr /></div>
                    </div>
                    {orderLines.map((o, i) => <div key={i} className="row mt-2 mb-4">
                        <div className="col-3">
                            <div className="text-small text-grey-tiny">QTY</div>
                            <div className="text-small">{o.quantity}</div>
                        </div>
                        <div className="col-3">
                            <div className="text-small text-grey-tiny">Price (per unit)</div>
                            <div className="text-small">£{roundNumber(o.item_price || 0)}</div>
                        </div>
                        <div className="col-3">
                            <div className="text-small text-grey-tiny">Total Excl. VAT</div>
                            <div className="text-small">£{roundNumber(o.line_price || 0)}</div>
                        </div>
                        <div className="col-3">
                            <div className="text-small text-grey-tiny text-center">&nbsp;</div>
                            <div className="text-small d-flex justify-content-end">
                                <div className="cursor-pointer" onClick={() => onMinus(i)}>
                                    <img src={TrashSvg} alt="trash" />
                                </div>
                            </div>
                        </div>
                        <div className="row pt-2">
                            <div className="col-12 text-small text-grey">
                                {o.product_quality} {o.colour_full_name} - Reference: {o.line_reference || 'N/A'}
                            </div>
                        </div>
                    </div>)}
                    <div className="row">
                        <div className="col-12"><hr /></div>
                    </div>
                    <div className="row">
                        <div className="col-6 font-bold"></div>
                        <div className="col-6 text-end">
                            <span className="font-bold text-small">Total&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span className="text-small">Excl. VAT &nbsp;&nbsp;&nbsp;</span>
                            <span className="font-bold text-orange">£{roundNumber(getOrderTotal())}</span>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <Button text="Add Order Summary to Basket and Continue Shopping" disabled={orderLines.length <= 0}
                                onClick={onAddOrderSummaryToBasketAndContinue}/>
                    </div>
                    <div className="row mt-4">
                        <Button text="Add Order Summary to Basket and Checkout" disabled={orderLines.length <= 0}
                                onClick={onAddOrderSummaryToBasket}/>
                    </div>
                </div>
            </div>
        </div>
  );
}
;

export default ProductCardY;
